// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import {
  FORGOT_PASSWORD
} from '../actions/user'

const initialState = {
  email: null,
}

export default function (state = initialState, action) {
  switch (action.type) {
    case FORGOT_PASSWORD:
      return {...state, email: action.payload.email}
    default:
      return state
  }
}

